import { programs } from '@/externals/gyym/user'
import {
  ProgramId,
  ListParams,
  ProgramDetails,
  SearchCountParams,
} from './types'
import { sortActivities } from '../Activities'
import { TimetableId } from '../Timetables'

export const listProgram = async (params: ListParams) => {
  const { data, meta } = await programs.list(params)

  return {
    data: data.map(({ activities, ...program }) => ({
      ...program,
      // プログラムのアクティビティを並べ替える
      activities: sortActivities(activities),
    })),
    meta,
  }
}

export const listOnlineProgram = async (params?: ListParams) => {
  const { data, meta } = await programs.list({ ...params, isOnline: true })

  return {
    data: data.map(({ activities, ...program }) => ({
      ...program,
      // プログラムのアクティビティを並べ替える
      activities: sortActivities(activities),
    })),
    meta,
  }
}

export const getProgram = async (
  programId: ProgramId
): Promise<ProgramDetails> => {
  const { activities, ...program } = await programs.get(programId)

  return {
    ...program,
    // プログラムのアクティビティを並べ替える
    activities: sortActivities(activities),
  }
}

export const listProgramTimetables = async (programId: ProgramId) => {
  return await programs.listTimetables(programId)
}

export const getProgramTimetable = async (
  programId: ProgramId,
  timetableId: TimetableId
) => {
  return await programs.getTimetable(programId, timetableId)
}

export const searchProgram = async () => {
  const res = await programs.search()
  return {
    ...res,
    activities: sortActivities(res.activities),
  }
}

export const searchProgramCount = async (params: SearchCountParams) => {
  return await programs.searchCount(params)
}
